<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="营销中心"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="market-list">
                <el-row :gutter="34">
                    <el-col :span="8">
                        <div class="item" @click="superGet">
                            <div class="icon super-get"></div>
                            <div class="show">
                                <div class="name">超级获客</div>
                                <div class="desc">
                                    店铺没有客户？这里让你门庭若市！
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="item">
                            <div class="icon super-get"></div>
                            <div class="show">
                                <div class="name">超级获客</div>
                                <div class="desc">
                                    店铺没有客户？这里让你门庭若市！
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="item">
                            <div class="icon super-get"></div>
                            <div class="show">
                                <div class="name">超级获客</div>
                                <div class="desc">
                                    店铺没有客户？这里让你门庭若市！
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>


            </div>
        </div>
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    export default {
        name: "Index",
        components: {RightTop},
        mounted: function () {
            this.$store.commit("setMenuId", "8");
        },
        methods: {
            superGet: function () {
                window.open("/market/super-get.html");
            }
        }
    }
</script>

<style scoped>
    .layout-right-body>.market-list{
        background: #ffffff;
        border-radius: 5px;
        padding: 16px 34px;
        flex: 1 1;
    }
    .item{
        padding: 20px;
        border: 1px solid #dddddd;
        display: flex;
        flex-flow: row nowrap;
        cursor: pointer;
    }
    .item:hover{
        border-color: #6cb1e1;
    }
    .item>.icon{
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background-repeat: no-repeat;
    }
    .item>.show{
        margin-left: 18px;
        flex: 1 1;
    }
    .item>.show>.name{
        font-size: 20px;
        font-weight: bold;
        color: #000000;
    }
    .item>.show>.desc{
        margin-top: 14px;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
    }
    .super-get{
        background-image: url("../../../../images/market/super_get.png");
    }
</style>
